export default __webpack_public_path__ + "static/011-7d90440c042fefdfb3e2516ebfe4103b.jpg";